import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import * as TagNames from './graphs.tagnames.ts';
import { AtlStatusOverviewBarItemProps } from './graphs.props.ts';

import StatusOverviewBarStyles from './status-overview-bars.scss?inline';

@customElement(TagNames.StatusOverviewBarItem)
export class AtlStatusOverviewBarItem
   extends LitElement
   implements AtlStatusOverviewBarItemProps
{
   declare progressLabel?: string;
   declare text?: string;
   declare value?: number;
   declare columnSize?: number;

   static properties = {
      progressLabel: { attribute: 'progress-label', type: String },
      text: { type: String },
      value: { type: Number },
      columnSize: { attribute: 'column-size', type: Number },
   };

   static styles = [StatusOverviewBarStyles];

   render() {
      return html`
         <div class="status-overview-bars">
            <div class="header">
               <div class="left-progress-label" part="label">
                  ${this.progressLabel}
               </div>
               <div part="text">${this.text}</div>
            </div>
            <div class="progress-container">
               <div class="progress">
                  <div
                     class="progress-bar"
                     style="width: ${this.value || 0}%"
                  ></div>
               </div>
            </div>
         </div>
      `;
   }
}
